import { useMutation } from '@tanstack/react-query';

import { stripeService } from '@/services/stripe';

export const useCreateStripeClient = () => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: (email?: string) =>
      stripeService.createClient({
        email,
      }),
    mutationKey: ['createStripeClient'],
    retry: (failureCount) => {
      return failureCount < 3;
    },
  });

  const createStripeClient = async (email?: string) => {
    try {
      return await mutateAsync(email);
    } catch (error) {
      console.error('Can not create a stripe user', error);
    }
  };

  return { createStripeClient, isCreatingStripeClient: isLoading };
};
